<div class="subscription-detail-container__item" [class.active]="active()">
  <div class="subscription-detail-container__item-left">
    @if (!isFirewall()) {
      <div
        class="subscription-detail-container__icon subscription-detail-container__icon--{{ productType() | lowercase }}"
      >
        <svg-icon src="assets/images/icons/{{ productType() | lowercase }}.svg"> </svg-icon>
      </div>
    } @else {
      <div class="subscription-detail-container__icon subscription-detail-container__icon--ip">
        <svg-icon src="assets/images/icons/ip.svg" />
        <span class="subscription-detail-container__icon-overlap-square">
          <svg-icon src="assets/images/icons/fw-overlap.svg" class="subscription-detail-container__overlap-icon" />
        </span>
      </div>
    }
    <span class="subscription-detail-container__item-title">{{ title() }}</span>
  </div>
  <div class="subscription-detail-container__item-right">
    @if (!isMsc()) {
      <span> {{ serviceSpeed() | service_speed }} </span>
    } @else {
      <span>-</span>
    }
    <svg-icon src="assets/images/icons/arrow-small-right.svg"></svg-icon>
  </div>
</div>
